import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { RTL_LANGUAGES } from 'constants/index';
import { getQueryStringParams } from 'utils';

function useDetectedLanguage(loading?: boolean, skip?: boolean) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (loading || skip) {
      return;
    }

    const { lang } = getQueryStringParams();

    if (lang) {
      i18n.changeLanguage(lang);

      // If the language is right-to-left then we need to change document direction.
      if (RTL_LANGUAGES.includes(lang)) {
        document.body.classList.add('rtl');
      } else {
        document.body.classList.remove('rtl');
      }
    }
  }, [i18n, loading, skip]);
}

export default useDetectedLanguage;
